import {popupWin} from "../assets-static/scripts/utils";

export let formatValues = {
    year: new Date().getFullYear(),
    br: <br />,
    'link-to-terms': (chunks) => <a href="#"
                                    onClick={() => popupWin('https://www.dualcitizenship.com/terms-of-use/')}>{chunks}</a>,
    'link-to-privacy': (chunks) => <a href="#"
                                      onClick={() => popupWin('https://www.dualcitizenship.com/privacy-policy')}>{chunks}</a>,
}
